<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(code)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(name)="data">
                <router-link class="text-data-link" :to="data.item.links.self"
                             v-text="data.item.data.attributes.name"/>
            </template>

            <template v-slot:cell(ssn)="data">
                <span v-text="data.item.data.attributes.ssn"/>
            </template>

            <template v-slot:cell(dob)="data">
                <span v-text="data.item.data.attributes.dob"/>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestNoShows",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'code', label: 'Code', tdClass: ''},
                        {key: 'name', label: 'Name', tdClass: ''},
                        {key: 'ssn', label: 'SSN', tdClass: 'text-muted'},
                        {key: 'dob', label: 'DOB', tdClass: 'text-muted'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
